import { render, staticRenderFns } from "./SingleAppointment.vue?vue&type=template&id=c5921392&scoped=true&"
import script from "./SingleAppointment.vue?vue&type=script&lang=js&"
export * from "./SingleAppointment.vue?vue&type=script&lang=js&"
import style0 from "./SingleAppointment.vue?vue&type=style&index=0&id=c5921392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5921392",
  null
  
)

export default component.exports